
import BarChart from './BarChart';
import ChartBase from './ChartBase';

export default {
  i18nComponentKey: 'WidgetProductReviewsStatistics.components.ChartPc',
  name: 'ChartPc',
  components: { BarChart },
  extends: ChartBase
};
